export default {
  skip_to_main_content: 'Ga naar hoofdinhoud',
  show_system_messages: 'Toon systeemberichten',
  dont_show_system_messages: 'Verberg systeem berichten',
  logged_in: 'Huurder is geverifieerd',
  logged_out: 'Anonieme gebruiker',
  button_tooltip_switch_locale: 'Verander taal',
  button_tooltip_activate_voice_recognition: 'Activeer stemherkenning',
  date_input: 'Selecteer datum',
  choose_two_dates: 'Kies twee datums',
  date_range: 'Datumbereik',
  from: 'van',
  to: 'naar',
  avatar: 'Avatar',
  exit: 'Einde',
  new: 'Nieuw',
  back: 'Terug',
  address: 'Adres',
  suggestions: 'Suggesties',
  senton: 'Verzonden op',
  message_placeholder: 'Vul hier je bericht in',
  message_aria: 'Vul hier je bericht in',
  upload_in_progress: 'Upload bezig...',
  comment_placeholder: 'Voer hier een opmerking in',
  message_button_label: 'Sturen',
  please_confirm: 'Bevestig alstublieft',
  no: 'Nee',
  yes: 'Ja',
  modal_delete_session: 'Sessie verwijderen',
  modal_delete_session_notification:
    'Als u het venster sluit, wordt uw sessie ook verwijderd.<br>Bent u het hiermee eens?',
  template_contact_time: 'Wanneer mogen we contact met u opnemen?',
  template_pause:
    'Je sessie werd gepauzeerd. Een van onze supportmedewerkers zal uw aanvraag binnenkort in behandeling nemen.',
  template_continue_after_pause:
    'Uw sessie werd voortgezet. U kunt nu verder schrijven met onze chatbot.',
  choose_date: 'Selecteer een datum en tijd',
  button_apply: 'Bevestigen',
  button_cancel: 'Afbreken',
  none: 'Geen',
  book_appointment: 'Boek een datum',
  address_input: 'Adresvermelding',
  data_processing: 'Gegevensverwerking',
  privacy_policy: 'Privacybeleid',
  data_processing_notification_before_link:
    'Om gebruik te maken van deze chatdienst is het noodzakelijk dat u het ',
  data_processing_notification_after_link: 'accepteert.',
  button_accept: 'Accepteer',
  select_date: 'Selecteer datum',
  rate_conversation: 'Hoe zou u dit gesprek waarderen?',
  new_ticket_question: 'Kan ik U nog ergens anders mee van dienst zijn?',
  thank_you:
    'Dank u voor uw steun. Jouw feedback helpt me om mezelf voortdurend te verbeteren.',
  goodbye: 'Tot ziens',
  start_new: 'Start nieuw gesprek',
  operator_entered_the_chat: 'Operator is het gesprek binnengekomen',
  operator_left_the_chat: 'Operator heeft het gesprek verlaten',
  bg_image: process.env.VUE_APP_NL_BG,
  expand_quickreplies: 'Meer',
  collapse_quickreplies: 'Minder',
  login: 'Inloggen',
  logout: 'Uitloggen',
  close: 'Sluiten',
  messenger_text: 'U kunt met onze chatbot schrijven of direct contact opnemen met een van onze medewerkers in onze live chat.',
  chat_bot: 'Chat Bot',
  live_bot: 'Live Chat',
  maximize: 'Maximaliseren',
  minimize: 'Minimaliseren',
  upload_file: 'Laat het bestand hier vallen om te uploaden',
  upload_file_or: 'of',
  Upload_file_select: 'Bestanden toevoegen',
  upload_file_text: 'Laat bestand vallen om te uploaden',
  show_attachments: 'Bijlage tonen',
  hide_attachments: 'Bijlage verbergen',
  tooBig: 'Het bestand is te groot',
  tooSmall: 'Het bestand is te klein',
  invalidFileTypeCopilot:
    'Ongeldig bestandstype. Momenteel worden alleen bestandstypen .png, .jpg, .jpeg, .gif ondersteund.',
  tooManyFiles: 'Upload maximaal 10 bestanden tegelijk',
  uploadError: 'Upload mislukt. Probeer het opnieuw.',
  maxDocumentsReached: 'Maximum aantal documenten (10) bereikt voor dit gesprek',
  no_text_content_detected: 'Geen tekstinhoud gedetecteerd in dit document',
  document_indexing_failed: 'Document kon niet worden geïndexeerd',
  showMore: 'Meer tonen',
  showLess: 'Minder tonen',
  chatProtocol: 'ChatProtocol',
  uploadTooltip: 'Upload bestand',
  uploadFilesTooltip: 'Upload bestanden',
  pdfDownloadTooltip: 'Download Gesprek',
  feedbackDescription: 'Feedback aan ons',
  feedbackSubtitle: {
    description:
      'Hier kunt u ons algemene suggesties, voorstellen en verzoeken sturen.',
    note: 'Houd er rekening mee dat wij deze niet kunnen beantwoorden.',
    hint:
      'Alle andere zorgen die specifiek betrekking hebben op uw huurwoning of het zoeken naar een appartement kunt u ons in de chat beschrijven.'
  },
  feedbackPlaceholder: 'Vul hier uw bericht in...',
  feedbackInfoPlaceholder: 'Voeg hier gerust specifieke details toe...',
  sendFeedback: 'Stuur',
  giveFeedback: 'Feedback aan ons',
  feedbackSubmittedSuccessfully: 'Uw feedback is succesvol verzonden',
  character_limit: 'Karakters',
  page: 'p.',
  factually_incorrect: 'Niet factueel correct',
  not_following_instructions: 'Instructies niet volledig gevolgd',
  info_not_in_document: 'Gevraagde informatie niet in document gevonden',
  inappropriate_or_offensive: 'Ongeschikt of beledigend',
  irrelevant: 'Niet Relevant',
  not_fitting_topic: 'Niet passend bij onderwerp',
  confusing_information: 'Verwarrende informatie',
  ignored_important_parts_of_document:
    'Belangrijke delen van document genegeerd',
  interpreted_document_wrong: 'Document verkeerd geïnterpreteerd',
  answer_to_generic: 'Antwoord te algemeen',
  sources_incorrect: 'Onbetrouwbare bronnen of fout geciteerd',
  why_not_helpful: 'Waarom was dit niet nuttig?',
  thank_you_feedback: 'Bedankt voor je feedback!',
  provide_feedback: 'Geef feedback op dit antwoord',
  not_helpful: 'Niet nuttig',
  helpful: 'Nuttig',
  regenerate_message: 'Opnieuw genereren',
  copy_message: 'Kopiëren',
  copied_message: 'Gekopieerd!',
  copy_table_csv: 'Tabel kopiëren',
  download_table_csv: 'CSV downloaden',
  expand_table: 'Tabel openen',
  print: 'Afdrukken',
  original_answer: 'Oorspronkelijk antwoord',
  regenerated_answer: 'Opnieuw gegenereerd antwoord',
  thinking_message: 'Ik denk na...',
  file_path: 'Bestandspad: ',
  new_messages: 'Nieuwe berichten',
  previous_message: 'Vorig bericht',
  next_message: 'Volgend bericht',
  clear_input: 'Invoer wissen',
  open_feedback: 'Feedback openen',
  file_upload: 'Bestand uploaden',
  expand_quickreplies_aria: 'Meer knoppen tonen',
  button_tooltip_switch_locale_german: 'Verander taal naar Duits',
  button_tooltip_switch_locale_french: 'Verander taal naar Frans',
  button_tooltip_switch_locale_dutch: 'Verander taal naar Nederlands',
  button_tooltip_switch_locale_turkish: 'Verander taal naar Turks',
  button_tooltip_switch_locale_russian: 'Verander taal naar Russisch',
  button_tooltip_switch_locale_swedish: 'Verander taal naar Zweeds',
  button_tooltip_switch_locale_ukranian: 'Verander taal naar Oekraïens',
  button_tooltip_switch_locale_spanish: 'Verander taal naar Spaans',
  button_tooltip_switch_locale_polish: 'Verander taal naar Pools',
  button_tooltip_switch_locale_arabic: 'Verander taal naar Arabisch',
  button_tooltip_switch_locale_italian: 'Verander taal naar Italiaans',
  button_tooltip_switch_locale_english: 'Verander taal naar Engels',
  message_from_you: 'Je zegt',
  message_from_bot: 'Bot zegt',
  message_from_operator: 'Agent zegt',
  new_message_from_bot: 'Bot zegt',
  empty_message_received: 'Leeg bericht ontvangen',
  open_quick_actions: 'Snelle acties openen',
  quick_actions: 'Snelle acties',
  quick_actions_search_hint: '...of blijf typen voor suggesties',
  quick_actions_no_results: 'Geen resultaten gevonden'
}
